function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#2e7d32",
    d: "M 287.5,79.5 C 287.5,100.833 287.5,122.167 287.5,143.5C 287.5,154.167 287.5,164.833 287.5,175.5C 287.5,186.167 287.5,196.833 287.5,207.5C 287.5,218.167 287.5,228.833 287.5,239.5C 287.5,250.167 287.5,260.833 287.5,271.5C 287.5,282.167 287.5,292.833 287.5,303.5C 287.5,314.167 287.5,324.833 287.5,335.5C 287.5,346.167 287.5,356.833 287.5,367.5C 287.5,388.833 287.5,410.167 287.5,431.5C 287.667,449.503 287.5,467.503 287,485.5C 283.719,492.139 278.386,495.473 271,495.5C 185.089,480.154 99.2556,464.32 13.5,448C 7.11828,446.657 2.45162,443.157 -0.5,437.5C -0.5,316.167 -0.5,194.833 -0.5,73.5C 2.45162,67.8434 7.11828,64.3434 13.5,63C 99.2556,46.6798 185.089,30.8465 271,15.5C 278.724,15.0278 284.057,18.3611 287,25.5C 287.5,43.4969 287.667,61.4969 287.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebeef0",
    d: "M 287.5,79.5 C 358.834,79.3333 430.167,79.5 501.5,80C 506.02,82.0223 509.353,85.189 511.5,89.5C 511.5,200.167 511.5,310.833 511.5,421.5C 509.353,425.811 506.02,428.978 501.5,431C 430.167,431.5 358.834,431.667 287.5,431.5C 287.5,410.167 287.5,388.833 287.5,367.5C 304.837,367.667 322.17,367.5 339.5,367C 350.907,362.121 354.074,353.954 349,342.5C 346.407,339.457 343.24,337.29 339.5,336C 322.17,335.5 304.837,335.333 287.5,335.5C 287.5,324.833 287.5,314.167 287.5,303.5C 304.837,303.667 322.17,303.5 339.5,303C 350.907,298.121 354.074,289.954 349,278.5C 346.407,275.457 343.24,273.29 339.5,272C 322.17,271.5 304.837,271.333 287.5,271.5C 287.5,260.833 287.5,250.167 287.5,239.5C 304.837,239.667 322.17,239.5 339.5,239C 350.907,234.121 354.074,225.954 349,214.5C 346.407,211.457 343.24,209.29 339.5,208C 322.17,207.5 304.837,207.333 287.5,207.5C 287.5,196.833 287.5,186.167 287.5,175.5C 304.837,175.667 322.17,175.5 339.5,175C 350.907,170.121 354.074,161.954 349,150.5C 346.407,147.457 343.24,145.29 339.5,144C 322.17,143.5 304.837,143.333 287.5,143.5C 287.5,122.167 287.5,100.833 287.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#388e3c",
    d: "M 287.5,143.5 C 304.837,143.333 322.17,143.5 339.5,144C 343.24,145.29 346.407,147.457 349,150.5C 354.074,161.954 350.907,170.121 339.5,175C 322.17,175.5 304.837,175.667 287.5,175.5C 287.5,164.833 287.5,154.167 287.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#398e3d",
    d: "M 395.5,143.5 C 409.906,143.051 424.239,143.551 438.5,145C 446.76,150.111 449.26,157.277 446,166.5C 443.685,170.817 440.185,173.65 435.5,175C 421.098,175.948 406.765,175.615 392.5,174C 383.436,168.134 381.269,160.3 386,150.5C 388.529,147.115 391.696,144.782 395.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f8f8",
    d: "M 202.5,159.5 C 217.366,158.864 224.199,165.864 223,180.5C 205.536,204.295 187.703,227.795 169.5,251C 186.877,271.575 204.377,292.075 222,312.5C 225.267,321.699 222.767,328.865 214.5,334C 208.428,336.417 202.761,335.751 197.5,332C 181.333,313.833 165.167,295.667 149,277.5C 134.62,295.758 120.12,313.925 105.5,332C 96.6677,337.537 88.8344,336.371 82,328.5C 79.3434,323.268 79.0101,317.934 81,312.5C 96.3088,292.357 111.809,272.357 127.5,252.5C 112.853,235.352 98.0198,218.352 83,201.5C 76.4587,190.288 78.9587,181.788 90.5,176C 95.9768,174.827 100.977,175.827 105.5,179C 118.974,194.974 132.974,210.474 147.5,225.5C 163.541,206.289 179.041,186.622 194,166.5C 196.628,163.79 199.461,161.456 202.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#388e3c",
    d: "M 287.5,207.5 C 304.837,207.333 322.17,207.5 339.5,208C 343.24,209.29 346.407,211.457 349,214.5C 354.074,225.954 350.907,234.121 339.5,239C 322.17,239.5 304.837,239.667 287.5,239.5C 287.5,228.833 287.5,218.167 287.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#398e3d",
    d: "M 395.5,207.5 C 409.906,207.051 424.239,207.551 438.5,209C 446.76,214.111 449.26,221.277 446,230.5C 443.685,234.817 440.185,237.65 435.5,239C 421.098,239.948 406.765,239.615 392.5,238C 383.436,232.134 381.269,224.3 386,214.5C 388.529,211.115 391.696,208.782 395.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#388e3c",
    d: "M 287.5,271.5 C 304.837,271.333 322.17,271.5 339.5,272C 343.24,273.29 346.407,275.457 349,278.5C 354.074,289.954 350.907,298.121 339.5,303C 322.17,303.5 304.837,303.667 287.5,303.5C 287.5,292.833 287.5,282.167 287.5,271.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#398e3d",
    d: "M 395.5,271.5 C 409.906,271.051 424.239,271.551 438.5,273C 446.76,278.111 449.26,285.277 446,294.5C 443.685,298.817 440.185,301.65 435.5,303C 421.098,303.948 406.765,303.615 392.5,302C 383.436,296.134 381.269,288.3 386,278.5C 388.529,275.115 391.696,272.782 395.5,271.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#388e3c",
    d: "M 287.5,335.5 C 304.837,335.333 322.17,335.5 339.5,336C 343.24,337.29 346.407,339.457 349,342.5C 354.074,353.954 350.907,362.121 339.5,367C 322.17,367.5 304.837,367.667 287.5,367.5C 287.5,356.833 287.5,346.167 287.5,335.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#398e3d",
    d: "M 395.5,335.5 C 409.906,335.051 424.239,335.551 438.5,337C 446.76,342.111 449.26,349.277 446,358.5C 443.685,362.817 440.185,365.65 435.5,367C 421.098,367.948 406.765,367.615 392.5,366C 383.436,360.134 381.269,352.3 386,342.5C 388.529,339.115 391.696,336.782 395.5,335.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.599e4e496ae4e00d3a5deb60d55619c9.svg";
export { ForwardRef as ReactComponent };